import { render } from "./CreateNewFrorm.vue?vue&type=template&id=427e96a8&scoped=true&ts=true"
import script from "./CreateNewFrorm.vue?vue&type=script&lang=ts"
export * from "./CreateNewFrorm.vue?vue&type=script&lang=ts"

import "./CreateNewFrorm.vue?vue&type=style&index=0&id=427e96a8&scoped=true&lang=css"
import "./CreateNewFrorm.vue?vue&type=style&index=1&id=427e96a8&scoped=true&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=2&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-427e96a8"]])

export default __exports__